<div appHeader class="header " [ngClass]="headerClasses" id="kt_header">
  <div class="d-flex align-items-center flex-wrap flex-sm-nowrap justify-content-start w-100 pl-8">
    <app-breadcrumbs></app-breadcrumbs>
  </div>
  <div [ngClass]="headerContainerClasses" class="d-flex align-items-stretch justify-content-end">
    <app-topbar class="topbar">
    </app-topbar>
  </div>
</div>